            $(function() {
                var topBtn = $('.btn_area');
            topBtn.hide();
            //スクロールが100に達したらボタン表示
            $(window).bind("scroll", function() {
            scrollHeight = $(document).height();
            scrollPosition = $(window).height() + $(window).scrollTop();
            if ( (scrollHeight - scrollPosition) / scrollHeight <= 0.01) {
                //スクロールの位置が下部5%の範囲に来た場合
                topBtn.fadeOut();
            } else {
                //それ以外のスクロールの位置の場合
                topBtn.fadeIn();
            }
        });
        });